import React from 'react'

import styles from './NetflixMediaVersions.module.scss'

const NetflixMediaVersionsNote = () => (
  <tr>
    <td className={styles.Note} colSpan={6}>
      These ratings reflect the overall classification of the season, and not
      classifications for individual episodes.
    </td>
  </tr>
)

export default NetflixMediaVersionsNote
